import React, { useMemo } from "react";
import { Box, Typography } from "@mui/material";
import PopupModal from "./Ui_elements/PopupModal";
import Btn from "./Ui_elements/Btn";
import TextFieldComponent from "./TextFieldComponent";

const JobRejectModal = ({
  open,
  title = "Reject Job",
  confirmText = "Yes",
  cancelText = "Close",
  reason,
  onChangeReason,
  onConfirm,
  onClose,
  isSubmitting = false,
  requiredErrorText = "Reason is required.",
}) => {
  const trimmedReason = (reason || "").trim();
  const reasonError = useMemo(() => {
    if (!open) return "";
    if (trimmedReason.length > 0) return "";
    return requiredErrorText;
  }, [open, trimmedReason, requiredErrorText]);

  return (
    <PopupModal
      open={open}
      maxWidth="sm"
      width="650px"
      title={title}
      handleClose={onClose}
      actions={
        <>
          <Btn onClick={onConfirm} disabled={isSubmitting || !trimmedReason}>
            {confirmText}
          </Btn>
          <Btn variant="outlined" onClick={onClose} disabled={isSubmitting}>
            {cancelText}
          </Btn>
        </>
      }
    >
      <Box>
        <Typography variant="body2" sx={{ mb: 1 }}>
          Please share a short reason. This will be sent to the project manager.
        </Typography>
        <TextFieldComponent
          label="Reason"
          value={reason}
          onChange={onChangeReason}
          placeHolder="Please enter reason for job rejection"
          multiline
          rows={4}
          error={reasonError}
        />
      </Box>
    </PopupModal>
  );
};

export default JobRejectModal;
